import React from 'react';
import styles from './ItemsList.css';
import { useSelector } from 'react-redux';
import { selectItemsListState } from '../../ducks';
import { ItemsList } from './ItemsList';
import { Link } from 'react-router-dom';
import { ClickElement } from '../form';
import { isToppers } from '../../apis/dumpert';
import { Loading } from '../loading';
import { SIDEBAR } from '../../lib/labels';

const SIDEBAR_ELEMENTS = {
  latest: {
    title: SIDEBAR.TITLE.NEW,
    moreItemsLink: { path: '/latest', title: SIDEBAR.BUTTON.NEW },
  },
  toppers: {
    title: SIDEBAR.TITLE.TOP,
    moreItemsLink: { path: '/toppers', title: SIDEBAR.BUTTON.TOP },
  },
  dumperttv: {
    title: SIDEBAR.TITLE.BRAND,
    moreItemsLink: { path: '/tag/dumperttv', title: SIDEBAR.BUTTON.BRAND },
  },
};

export const ItemsListSidebar = ({ typeOfList, numOfItems }) => {
  const { isLoading, isLoaded, error, items } = useSelector(state => selectItemsListState(state, typeOfList));

  const { title, moreItemsLink } = SIDEBAR_ELEMENTS[typeOfList];
  const listProps = {
    items: items.slice(0, numOfItems),
    isToppers: isToppers(typeOfList),
    isSidebar: true,
  };

  return (
    <>
      {error && <></>}
      {isLoading && <Loading whatIsLoading="items"/>}
      {isLoaded && <div className={styles.itemslist}>
        <h2>{title}</h2>
        <div className={'grid one'}>
          <ItemsList {...listProps} />
        </div>
        <ClickElement
          tertiary
          ElementType={Link}
          text={moreItemsLink.title}
          to={moreItemsLink.path}
          style={{ 'marginBottom': '0' }}
        />
        <div className={'spacer'}></div>
      </div>}
    </>
  );
};